import exceptionsService from "../shared/services/exceptionsService";

const REQUEST_EXCEPTIONS = "REQUEST_EXCEPTIONS";
const RESPONSE_EXCEPTIONS = "RESPONSE_EXCEPTIONS";
const REQUEST_EXCEPTIONS_FAULURE = "REQUEST_EXCEPTIONS_FAULURE";

const requestExceptionsAction = () => {
  return {
    type: REQUEST_EXCEPTIONS,
  };
};

const responseExceptionsAction = (data) => {
  return {
    type: RESPONSE_EXCEPTIONS,
    data,
  };
};

const requestExceptionsFailureAction = () => {
  return {
    type: REQUEST_EXCEPTIONS_FAULURE,
  };
};

const getExceptions = (options) => {
  return (dispatch) => {
    dispatch(requestExceptionsAction());

    exceptionsService
      .getExceptions(options)
      .then((result) => {
        dispatch(responseExceptionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestExceptionsFailureAction());
      });
  };
};

const REQUEST_DELETE_EXCEPTIONS = "REQUEST_DELETE_EXCEPTIONS";
const RESPONSE_DELETE_EXCEPTIONS = "RESPONSE_DELETE_EXCEPTIONS";
const REQUEST_DELETE_EXCEPTIONS_FAULURE = "REQUEST_DELETE_EXCEPTIONS_FAULURE";

const requestExceptionsDeleteAction = () => {
  return {
    type: REQUEST_DELETE_EXCEPTIONS,
  };
};

const responseExceptionsDeleteAction = (data) => {
  return {
    type: RESPONSE_DELETE_EXCEPTIONS,
    data,
  };
};

const requestExceptionsDeleteFailureAction = () => {
  return {
    type: REQUEST_DELETE_EXCEPTIONS_FAULURE,
  };
};

const deleteExceptions = (options) => {
  return (dispatch) => {
    dispatch(requestExceptionsDeleteAction());

    exceptionsService
      .deleteExceptions(options)
      .then((result) => {
        dispatch(responseExceptionsDeleteAction(options));
      })
      .catch((error) => {
        dispatch(requestExceptionsDeleteFailureAction());
      });
  };
};

export {
  REQUEST_EXCEPTIONS,
  RESPONSE_EXCEPTIONS,
  REQUEST_EXCEPTIONS_FAULURE,
  getExceptions,
  REQUEST_DELETE_EXCEPTIONS,
  RESPONSE_DELETE_EXCEPTIONS,
  REQUEST_DELETE_EXCEPTIONS_FAULURE,
  deleteExceptions,
};
